import React, { FC, useEffect } from 'react';
import { Button, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { EPlaceholder } from 'common/const/placeholder.enum';
import { EFormFieldError, EFormFieldMessage } from 'common/const/form.enum';
import { ERoute } from 'common/const/route.enum';
import { renderRequiredMark, rules } from 'common/helpers/form.helper';
import { ReactComponent as EyeOnIcon } from 'app/assets/images/redesign/eyeOn.svg';
import { ReactComponent as EyeOffIcon } from 'app/assets/images/redesign/eyeOff.svg';
import { IAuthLoginPayload } from 'entities/Auth/Auth.models';

interface IComponentProps {
  loading: boolean;
  error: string | null;
  onSubmit: (value: IAuthLoginPayload) => void;
}

export const LoginByCredentials: FC<IComponentProps> = ({ loading, error, onSubmit }) => {
  const [form] = useForm();

  useEffect(() => {
    if (error) {
      form.setFields([
        {
          name: error === EFormFieldError.IncorrectPassword ? 'password' : 'email',
          errors: [error],
        },
      ]);
    }
  }, [error]);

  return (
    <Form className="auth-card__content-form" form={form} layout="vertical" requiredMark={renderRequiredMark} onFinish={onSubmit}>
      <div className="mb-11 auth-card__content-form-title">Пожалуйста, введите вашу почту и пароль</div>

      <div className="mb-5 w-100">
        <Form.Item
          label="Логин"
          name="email"
          rules={[rules.required(), rules.type('email', EFormFieldMessage.InvalidEmailFormat)]}
        >
          <Input placeholder={EPlaceholder.EnterEmailAddress} />
        </Form.Item>

        <div className="relative">
          <Form.Item label="Пароль" name="password" rules={[rules.required()]}>
            <Input.Password
              placeholder={EPlaceholder.EnterPassword}
              iconRender={(visible) => (visible ? <EyeOnIcon /> : <EyeOffIcon />)}
            />
          </Form.Item>

          <div className="absolute" style={{ top: 0, right: 0 }}>
            <a className="ff-semibold fs-xs color-dark-green text-decoration-none" href={ERoute.RestorePassword}>
              Забыли пароль?
            </a>
          </div>
        </div>
      </div>

      <Button className="button-lg primary w-100" loading={loading} htmlType="submit">
        Войти
      </Button>
    </Form>
  );
};
